module.exports = __webpack_public_path__ + "static/img/3.70395dc.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/2/5/eng/3.png
// module id = dbUr
// module chunks = 0